import { render, staticRenderFns } from "./ObjectsCountTab.vue?vue&type=template&id=85582c9e&"
import script from "./ObjectsCountTab.vue?vue&type=script&lang=js&"
export * from "./ObjectsCountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports